<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { reportMethods, reportComputed } from "@/state/helpers";

export default {
    page: {
        title: "Stock Report",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Stock Report",
            items: [{ text: "Reports" }, { text: "Stock", active: true }],
            search: "",
            activeOnly: true,
            lowStockOnly: false,
            exporting: false,
            fields: [
                { key: "sku", label: "SKU", sortable: true },
                { key: "name", label: "Product", sortable: true },
                { key: "group", label: "Group", sortable: true },
                { key: "stock_quantity", label: "Stock", sortable: true, class: "text-right" },
                { key: "low_stock_threshold", label: "Min", class: "text-right" },
                { key: "price", label: "Price", formatter: (v) => "R " + Number(v).toFixed(2), class: "text-right" },
                { key: "active", label: "Active" },
            ],
        };
    },
    computed: {
        ...reportComputed,
        params() {
            return {
                ...(this.activeOnly ? { active: 1 } : {}),
                ...(this.lowStockOnly ? { low_stock_only: 1 } : {}),
                ...(this.search ? { search: this.search } : {}),
            };
        },
    },
    mounted() {
        this.reload();
    },
    methods: {
        ...reportMethods,
        reload() {
            this.getStockList(this.params).catch(() => {});
        },
        rowClass(item) {
            if (!item) return "";
            return item.low_stock ? "table-warning" : "";
        },
        async doExport() {
            this.exporting = true;
            try {
                await this.exportStockXlsx(this.params);
            } finally {
                this.exporting = false;
            }
        },
    },
    watch: {
        activeOnly: "reload",
        lowStockOnly: "reload",
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row mb-3 align-items-end">
            <div class="col-md-4">
                <label class="form-label small text-muted mb-1">Search</label>
                <b-input-group>
                    <b-form-input v-model="search" placeholder="SKU or product name" @keyup.enter="reload" />
                    <b-input-group-append>
                        <b-button variant="primary" @click="reload">
                            <i class="fa fa-search" />
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </div>
            <div class="col-md-2">
                <b-form-checkbox v-model="activeOnly">Active only</b-form-checkbox>
                <b-form-checkbox v-model="lowStockOnly">Low stock only</b-form-checkbox>
            </div>
            <div class="col-md-6 text-md-right">
                <b-button variant="success" @click="doExport" :disabled="exporting">
                    <i class="fa fa-file-excel" /> {{ exporting ? "Building..." : "Download Excel" }}
                </b-button>
            </div>
        </div>

        <b-card>
            <b-table
                :items="stock_rows"
                :fields="fields"
                :busy="stock_loading"
                :tbody-tr-class="rowClass"
                small
                striped
                hover
                responsive
                show-empty
                empty-text="No products match the filters."
            >
                <template #cell(active)="data">
                    <b-badge :variant="data.item.active ? 'success' : 'secondary'">
                        {{ data.item.active ? "Yes" : "No" }}
                    </b-badge>
                </template>
                <template #table-busy>
                    <div class="text-center text-muted my-3">
                        <b-spinner small /> Loading…
                    </div>
                </template>
            </b-table>
        </b-card>

        <p class="small text-muted mt-2">
            <i class="fa fa-info-circle" /> Rows highlighted in amber are at or below their low-stock threshold.
        </p>
    </Layout>
</template>
